"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TradeOperationTypeEnum = void 0;
var TradeOperationTypeEnum;
(function (TradeOperationTypeEnum) {
    TradeOperationTypeEnum["CryptoConversion"] = "cryptoConversion";
})(TradeOperationTypeEnum = exports.TradeOperationTypeEnum || (exports.TradeOperationTypeEnum = {}));
//# sourceMappingURL=trade-operation-type-enum.js.map